/**
 * Error wording for the agent route (F-144) — the statuses `api/agent.ts`
 * sends, each turned into what the person can DO about it. The upstream
 * classes are shared with Ask AI (`features/script/brainstorm.ts`).
 */
import { upstreamMessage } from "../script/brainstorm.js";

export function agentErrorMessage(status: number, code: string, model?: string): string {
  switch (code) {
    case "agent-not-configured":
      return "The board agent is not configured on this server yet (it needs an AI provider with tool calling).";
    case "server-draining":
      return "The server is restarting — try again in a few seconds.";
    case "rate-limited":
      return "You've sent a lot of requests recently — give it a minute.";
    case "too-many-concurrent":
      return "Another request is still running — wait for it to finish.";
    case "invalid-model":
      return "That model id isn't a shape the provider accepts. Pick one from the list.";
    case "unknown-sheet":
      return "This sheet changed under us — try again.";
    case "duplicate-attachment-id":
      return "Attach the files again and resend.";
    case "unusable-response":
      return "The agent came back with nothing usable. Try rephrasing, or pick another model.";
  }
  const upstream = upstreamMessage(code, model);
  if (upstream !== null) return upstream;
  if (status === 413) return "Those files are too big to send together — attach fewer, or smaller, files.";
  if (status === 400) return "The request was refused — try a shorter message or smaller files.";
  if (status === 403) return "You don't have permission to edit this board.";
  if (status === 404) return "This board no longer exists.";
  return "Couldn't reach the agent. Try again.";
}
